import { render, staticRenderFns } from "./EBotaoAtendimentoIA.vue?vue&type=template&id=75265c66"
import script from "./EBotaoAtendimentoIA.vue?vue&type=script&lang=js"
export * from "./EBotaoAtendimentoIA.vue?vue&type=script&lang=js"
import style0 from "./EBotaoAtendimentoIA.vue?vue&type=style&index=0&id=75265c66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports